window.onload = () => {
    // Only initialize on desktop devices (screen width > 768px)
    if (window.innerWidth > 768) {
        initProductImageModal();
    }
}

function initProductImageModal() {
    // Create modal HTML structure
    const modalHTML = `
        <div id="product-image-modal" class="product-image-modal" style="display: none;">
            <div class="modal-overlay"></div>
            <div class="modal-container">
                <button class="modal-close" aria-label="Close modal">&times;</button>
                <div class="modal-content">
                    <div class="modal-media-container">
                        <img class="modal-image" src="" alt="" style="display: none;">
                        <video class="modal-video" controls style="display: none;">
                            <source src="" type="video/mp4">
                        </video>
                    </div>
                    <div class="modal-counter">
                        <span class="current-image">1</span> / <span class="total-images">1</span>
                    </div>
                </div>
                <div class="modal-thumbnails"></div>
            </div>
        </div>
    `;

    // Add modal to body
    document.body.insertAdjacentHTML('beforeend', modalHTML);

    // Add modal styles
    const modalStyles = `
        <style>
            .product-image-modal {
                position: fixed;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                z-index: 9999;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            
            .modal-overlay {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: rgba(0, 0, 0, 0.9);
                cursor: pointer;
            }
            
            .modal-container {
                position: relative;
                width: 100vw;
                height: 100vh;
                display: flex;
                flex-direction: row;
                align-items: center;
            }
            
            .modal-close {
                position: absolute;
                top: 20px;
                right: 20px;
                background: rgba(0, 0, 0, 0.5);
                border: none;
                color: white;
                font-size: 2rem;
                cursor: pointer;
                z-index: 10001;
                padding: 10px 15px;
                border-radius: 50%;
                width: 50px;
                height: 50px;
                display: flex;
                align-items: center;
                justify-content: center;
            }
            
            
            .modal-content {
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                flex: 1;
                height: 100vh;
                justify-content: flex-start;
                overflow-y: auto;
                overflow-x: hidden;
                padding: 20px 0;
                scrollbar-width: none; /* Firefox */
                -ms-overflow-style: none; /* Internet Explorer 10+ */
            }
            
            .modal-content::-webkit-scrollbar {
                display: none; /* WebKit browsers (Chrome, Safari, Edge) */
            }
            
            .modal-media-container {
                position: relative;
                width: 80vw;
                height: auto;
                display: flex;
                justify-content: center;
                align-items: flex-start;
                min-height: 100vh;
            }
            
            .modal-image,
            .modal-video {
                width: 80vw;
                height: auto;
                object-fit: contain;
                cursor: zoom-out;
            }
            
            .modal-video {
                width: 80vw;
                height: auto;
            }
            
            .modal-counter {
                color: white;
                margin-top: 15px;
                font-size: 1.1rem;
            }
            
            .modal-thumbnails {
                position: fixed;
                left: 20px;
                top: 50%;
                transform: translateY(-50%);
                display: flex;
                flex-direction: column;
                gap: 10px;
                max-height: 80vh;
                overflow-y: auto;
                overflow-x: hidden;
                padding: 10px 0;
                z-index: 10000;
                scrollbar-width: none; /* Firefox */
                -ms-overflow-style: none; /* Internet Explorer 10+ */
            }
            
            .modal-thumbnails::-webkit-scrollbar {
                display: none; /* WebKit browsers (Chrome, Safari, Edge) */
            }
            
            .thumbnail {
                width: 80px;
                height: 80px;
                object-fit: cover;
                border-radius: 8px;
                cursor: pointer;
                opacity: 0.6;
                transition: all 0.3s ease;
                border: 2px solid transparent;
            }
            
            .thumbnail:hover,
            .thumbnail.active {
                opacity: 1;
                border-color: white;
            }
            
            .slider__slide {
                cursor: zoom-in;
            }
            
            @media (max-width: 768px) {
                .modal-thumbnails {
                    left: 10px;
                    max-height: 70vh;
                }
                
                .thumbnail {
                    width: 60px;
                    height: 60px;
                }
                
                .modal-close {
                    top: 15px;
                    right: 15px;
                    width: 40px;
                    height: 40px;
                    font-size: 1.5rem;
                }
            }
        </style>
    `;

    document.head.insertAdjacentHTML('beforeend', modalStyles);

    // Get modal elements
    const modal = document.getElementById('product-image-modal');
    const modalImage = modal.querySelector('.modal-image');
    const modalVideo = modal.querySelector('.modal-video');
    const modalVideoSource = modalVideo.querySelector('source');
    const modalClose = modal.querySelector('.modal-close');
    const modalOverlay = modal.querySelector('.modal-overlay');
    const currentImageSpan = modal.querySelector('.current-image');
    const totalImagesSpan = modal.querySelector('.total-images');
    const thumbnailsContainer = modal.querySelector('.modal-thumbnails');

    // Get all slider slides
    const sliderSlides = document.querySelectorAll('.slider__slide');
    let currentImageIndex = 0;
    let images = [];

    // Extract image data from slider
    function extractImageData() {
        images = [];
        sliderSlides.forEach((slide, index) => {
            // Look for video first, then image
            const video = slide.querySelector('video');
            const img = slide.querySelector('img');

            if (video) {
                const poster = video.getAttribute('poster');
                const videoSrc = video.querySelector('source')?.getAttribute('src');
                const alt = video.getAttribute('aria-label') || `Product video ${index + 1}`;

                images.push({
                    url: videoSrc || poster,
                    poster: poster,
                    alt: alt,
                    type: 'video',
                    videoElement: video
                });
            } else if (img) {
                const srcset = img.getAttribute('srcset');
                const src = img.getAttribute('src');
                const alt = img.getAttribute('alt') || `Product image ${index + 1}`;

                // Get the highest resolution image from srcset
                let imageUrl = src;
                if (srcset) {
                    const srcsetParts = srcset.split(',');
                    const highestRes = srcsetParts[srcsetParts.length - 1].trim().split(' ')[0];
                    imageUrl = highestRes;
                }

                images.push({
                    url: imageUrl,
                    alt: alt,
                    type: 'image'
                });
            }
        });
    }

    // Create thumbnails
    function createThumbnails() {
        thumbnailsContainer.innerHTML = '';
        images.forEach((image, index) => {
            const thumbnail = document.createElement('img');

            // Use poster image for video thumbnails, regular image for others
            if (image.type === 'video') {
                thumbnail.src = image.poster || image.url;
            } else {
                thumbnail.src = image.url;
            }

            thumbnail.alt = image.alt;
            thumbnail.className = 'thumbnail';
            if (index === 0) thumbnail.classList.add('active');

            // Add video indicator for video thumbnails
            if (image.type === 'video') {
                const videoIndicator = document.createElement('div');
                videoIndicator.className = 'video-indicator';
                videoIndicator.innerHTML = '▶';
                videoIndicator.style.cssText = `
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    background: rgba(0, 0, 0, 0.7);
                    color: white;
                    border-radius: 50%;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 10px;
                    pointer-events: none;
                `;

                const thumbnailContainer = document.createElement('div');
                thumbnailContainer.style.position = 'relative';
                thumbnailContainer.appendChild(thumbnail);
                thumbnailContainer.appendChild(videoIndicator);
                thumbnailContainer.addEventListener('click', () => {
                    currentImageIndex = index;
                    updateModalImage();
                    updateThumbnails();
                });

                thumbnailsContainer.appendChild(thumbnailContainer);
            } else {
                thumbnail.addEventListener('click', () => {
                    currentImageIndex = index;
                    updateModalImage();
                    updateThumbnails();
                });

                thumbnailsContainer.appendChild(thumbnail);
            }
        });
    }

    // Update modal image
    function updateModalImage() {
        const currentImage = images[currentImageIndex];
        if (!currentImage) return;

        // Hide both elements first
        modalImage.style.display = 'none';
        modalVideo.style.display = 'none';

        if (currentImage.type === 'video') {
            // Show video element
            modalVideo.style.display = 'block';
            modalVideoSource.src = currentImage.url;
            modalVideo.load(); // Reload video with new source
            modalVideo.setAttribute('aria-label', currentImage.alt);

            // Autoplay video when clicked
            modalVideo.addEventListener('loadeddata', () => {
                modalVideo.play().catch(e => {
                    console.log('Autoplay prevented:', e);
                });
            }, { once: true });
        } else {
            // Show image element
            modalImage.style.display = 'block';
            modalImage.src = currentImage.url;
            modalImage.alt = currentImage.alt;
        }

        currentImageSpan.textContent = currentImageIndex + 1;
        totalImagesSpan.textContent = images.length;
    }

    // Update thumbnail states
    function updateThumbnails() {
        const thumbnails = thumbnailsContainer.querySelectorAll('.thumbnail');
        thumbnails.forEach((thumb, index) => {
            thumb.classList.toggle('active', index === currentImageIndex);
        });
    }

    // Pause video when modal is closed or when navigating away from video
    function pauseCurrentVideo() {
        if (modalVideo.style.display !== 'none') {
            modalVideo.pause();
        }
    }

    // Open modal
    function openModal(imageIndex) {
        currentImageIndex = imageIndex;
        updateModalImage();
        updateThumbnails();
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
    }

    // Close modal
    function closeModal() {
        pauseCurrentVideo();
        modal.style.display = 'none';
        document.body.style.overflow = '';
    }


    // Event listeners
    modalClose.addEventListener('click', closeModal);
    modalOverlay.addEventListener('click', closeModal);
    modalImage.addEventListener('click', closeModal);
    modalVideo.addEventListener('click', closeModal);

    // Keyboard navigation
    document.addEventListener('keydown', (e) => {
        if (modal.style.display === 'none') return;

        switch (e.key) {
            case 'Escape':
                closeModal();
                break;
        }
    });


    // Add click listeners to slider slides (only on desktop)
    if (window.innerWidth > 768) {
        sliderSlides.forEach((slide, index) => {
            slide.addEventListener('click', (e) => {
                e.preventDefault();
                extractImageData();
                createThumbnails();
                openModal(index);
            });
        });
    }

    // Initialize
    extractImageData();
    createThumbnails();
}